import React, { useEffect, createElement } from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { CTAButton } from '../components/CTAButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { BonusItem } from '../components/BonusItem';
import { FAQItem } from '../components/FAQItem';
import { CheckIcon, ShieldCheckIcon, TrendingUpIcon, ZapIcon } from 'lucide-react';
const PIXEL_ID = '1206725874775777';
const fbTrack = (...args: any[]) => {
  try {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq(...args);
    }
  } catch (e) {
    // Pixel not available
  }
};
export function LandingPage() {
  useEffect(() => {
    try {
      const script = document.createElement('script');
      script.innerHTML = `
        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
        n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];if(s&&s.parentNode){s.parentNode.insertBefore(t,s)}
        else{b.head.appendChild(t)}}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
        fbq('init','${PIXEL_ID}');
        fbq('track','PageView');
      `;
      document.head.appendChild(script);
    } catch (e) {
      // Pixel initialization failed - will work in production
    }
  }, []);
  const handleBuyClick = () => {
    fbTrack('track', 'AddToCart', {
      content_name: 'The Prime Architect 40+',
      content_type: 'product',
      value: 6.39,
      currency: 'USD'
    });
    window.location.href = 'https://www.flujovital360.com/cart/46017124925636:1';
  };
  const scrollToCTA = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <div className="min-h-screen w-full bg-black text-white" data-id="element-31">
      <UrgencyBar data-id="element-32" />

      {/* Hero Section */}
      <section className="pt-52 md:pt-32 pb-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-33">
        <div className="max-w-7xl mx-auto" data-id="element-34">
          <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-35">
            <div className="space-y-8" data-id="element-36">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight" data-id="element-37">
                How to Reclaim the Vigor and Body of Your{' '}
                <span className="text-gradient" data-id="element-38">20s in Just 90 Days</span>
              </h1>

              <p className="text-xl md:text-2xl text-gray-300 font-semibold" data-id="element-39">
                Without Unnecessary Medical Therapies, No 'Starvation Diets' and
                Training Just 35 Minutes...
              </p>

              <p className="text-lg text-gray-400 leading-relaxed" data-id="element-40">
                — Even If You Feel Like Your Metabolism Has Completely Shut
                Down.
              </p>

              <div className="bg-zinc-900 border-l-4 border-cyan-500 p-6 rounded-r-lg" data-id="element-41">
                <p className="text-gray-300 italic" data-id="element-42">
                  "The Hormonal Architecture Protocol designed specifically for
                  men over 40 who are tired of feeling fatigued, overweight, and
                  'out of the game' in their own life."
                </p>
              </div>

              <CTAButton size="large" className="w-full md:w-auto" onClick={scrollToCTA} data-id="element-43">
                INSTANT ACCESS TO THE PLAN
              </CTAButton>
            </div>

            <div className="relative" data-id="element-44">
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-blue-500/20 blur-3xl" data-id="element-45"></div>
              <img src="https://cdn.magicpatterns.com/uploads/31rQyWbxgqhoYaZSyBprF1/Imagen_2.png" alt="The Prime Architect 40+ - Digital product with book, tablet and smartphone showing the system" className="relative z-10 w-full rounded-lg shadow-2xl" data-id="element-46" />
            </div>
          </div>
        </div>
      </section>

      {/* Hook Section */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-47">
        <div className="max-w-4xl mx-auto" data-id="element-48">
          <div className="bg-zinc-900 border border-cyan-500/30 rounded-xl p-8 md:p-12" data-id="element-49">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-center" data-id="element-50">
              Have you ever looked in the mirror and wondered...
            </h2>
            <p className="text-xl text-gray-300 leading-relaxed text-center mb-6" data-id="element-51">
              Where did that man full of energy and confidence you used to be
              go?
            </p>
            <p className="text-gray-400 leading-relaxed" data-id="element-52">
              You're not alone. In the last 10 years, testosterone levels in
              American men have dropped to historic lows, and the "wellness"
              industry wants you to believe that the only solution is injecting
              hormones for life or accepting the 'dad bod'.
            </p>
            <p className="text-cyan-400 font-bold text-xl mt-6 text-center" data-id="element-53">
              But there is a different path.
            </p>
          </div>
        </div>
      </section>

      {/* Pain Agitation Section */}
      <section className="py-16 px-4 bg-black" data-id="element-54">
        <div className="max-w-6xl mx-auto" data-id="element-55">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-56">
            You work hard. You are the provider. You are the leader.
            <br data-id="element-57" />
            <span className="text-red-500" data-id="element-58">
              But inside, you feel the engine shutting down.
            </span>
          </h2>

          <div className="grid md:grid-cols-2 gap-6 mb-12" data-id="element-59">
            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 space-y-4" data-id="element-60">
              <div className="flex items-start gap-3" data-id="element-61">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-62"></div>
                <p className="text-gray-300" data-id="element-63">
                  You hit 3 PM and the{' '}
                  <strong className="text-white" data-id="element-64">"brain fog"</strong> makes it
                  impossible to focus on that crucial meeting.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-65">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-66"></div>
                <p className="text-gray-300" data-id="element-67">
                  You get home and{' '}
                  <strong className="text-white" data-id="element-68">have no energy</strong> to play
                  with your kids, let alone connect with your wife.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-69">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-70"></div>
                <p className="text-gray-300" data-id="element-71">
                  You watch your{' '}
                  <strong className="text-white" data-id="element-72">waistline expand</strong> even
                  though you "eat healthy".
                </p>
              </div>
            </div>

            <div className="bg-zinc-900 border border-zinc-800 rounded-lg p-6 space-y-4" data-id="element-73">
              <div className="flex items-start gap-3" data-id="element-74">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-75"></div>
                <p className="text-gray-300" data-id="element-76">
                  You feel your{' '}
                  <strong className="text-white" data-id="element-77">joints stiff</strong> when you
                  wake up.
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-78">
                <div className="w-2 h-2 bg-red-500 rounded-full mt-2 flex-shrink-0" data-id="element-79"></div>
                <p className="text-gray-300" data-id="element-80">
                  And worst of all: that{' '}
                  <strong className="text-white" data-id="element-81">subtle fear</strong> that your
                  best years are behind you.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-r from-red-900/20 to-orange-900/20 border border-red-500/30 rounded-xl p-8 text-center" data-id="element-82">
            <p className="text-xl text-gray-300 mb-4" data-id="element-83">
              You've been sold the idea that{' '}
              <strong className="text-white" data-id="element-84">"it's just age"</strong>, but
              modern science tells us it's a failure in your biological
              architecture.
            </p>
            <p className="text-2xl font-bold text-red-400" data-id="element-85">
              You're running 45-year-old software on hardware that has never
              been updated, and your body is screaming for help.
            </p>
          </div>
        </div>
      </section>

      {/* Solution Reveal */}
      <section className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-86">
        <div className="max-w-6xl mx-auto" data-id="element-87">
          <div className="grid lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-88">
            <div data-id="element-89">
              <div className="inline-block bg-cyan-500/10 border border-cyan-500 rounded-full px-6 py-2 mb-6" data-id="element-90">
                <p className="text-cyan-400 font-bold" data-id="element-91">THE REVELATION</p>
              </div>

              <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-92">
                After analyzing thousands of biological markers, we discovered
                the truth:
              </h2>

              <div className="space-y-4 mb-8" data-id="element-93">
                <div className="flex items-start gap-3" data-id="element-94">
                  <ZapIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-95" />
                  <p className="text-gray-300" data-id="element-96">
                    Your body{' '}
                    <strong className="text-white" data-id="element-97">hasn't forgotten</strong> how
                    to produce vitality; it's simply{' '}
                    <strong className="text-cyan-400" data-id="element-98">"blocked"</strong> by
                    inflammation and insulin resistance.
                  </p>
                </div>

                <div className="flex items-start gap-3" data-id="element-99">
                  <TrendingUpIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-100" />
                  <p className="text-gray-300" data-id="element-101">
                    Most fitness programs fail because they're designed for
                    20-year-olds with explosive hormones.
                  </p>
                </div>

                <div className="flex items-start gap-3" data-id="element-102">
                  <CheckIcon className="h-6 w-6 text-cyan-400 flex-shrink-0 mt-1" aria-hidden="true" data-id="element-103" />
                  <p className="text-gray-300" data-id="element-104">
                    You need a{' '}
                    <strong className="text-white" data-id="element-105">Metabolic Precision</strong>{' '}
                    system that works{' '}
                    <strong className="text-cyan-400" data-id="element-106">WITH</strong> your current
                    biology, not against it.
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-cyan-500/20 to-blue-500/20 border border-cyan-500 rounded-xl p-8 text-center" data-id="element-107">
                <p className="text-2xl md:text-3xl font-bold mb-2" data-id="element-108">
                  Introducing:
                </p>
                <p className="text-4xl md:text-5xl font-extrabold text-gradient" data-id="element-109">
                  The Prime Architect 40+
                </p>
              </div>
            </div>

            <div className="relative" data-id="element-110">
              <div className="absolute inset-0 bg-gradient-to-r from-blue-500/20 to-cyan-500/20 blur-3xl" data-id="element-111"></div>
              <img src="https://cdn.magicpatterns.com/uploads/kwkTuukb3uuekR8yZETrQr/Imagen_1_T.png" alt="The Prime Architect 40+ - Complete system shown on digital devices" className="relative z-10 w-full rounded-lg shadow-2xl" data-id="element-112" />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-113">
        <div className="max-w-6xl mx-auto" data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-center" data-id="element-115">
            Real Results from Real Men
          </h2>
          <p className="text-xl text-gray-400 mb-12 text-center" data-id="element-116">
            Thousands of men over 40 have already reclaimed their vigor
          </p>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-117">
            <TestimonialCard name="Marc S." location="Austin, TX" result="Result: -12lbs of fat in 30 days" quote="At 47, I thought my 'dad bod' was permanent. After 4 weeks with Prime Architect, my energy doubled. I've lost 12 pounds of belly fat and my shirts are tight in the arms again, not the waist. My wife says I look like a different man." data-id="element-118" />

            <TestimonialCard name="David R." location="Chicago, IL" result="Result: Optimized Free-T from 350 to 720 ng/dL" quote="The best part is the mental clarity. The 'brain fog' disappeared in the first week. I train 35 minutes and perform better in my business than when I was 30. This is the manual every man my age should receive when they turn 40." data-id="element-119" />

            <TestimonialCard name="Robert L." location="Miami, FL" result="Result: Total post-work energy recovery" quote="I was skeptical. I thought I needed TRT. This protocol taught me to read my own bloodwork and use Costco nutrition to my advantage. My libido came back and my knee pain disappeared. Incredible." data-id="element-120" />
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section id="pricing" className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-121">
        <div className="max-w-4xl mx-auto" data-id="element-122">
          <div className="bg-zinc-900 border-2 border-cyan-500 rounded-2xl p-8 md:p-12 shadow-2xl" data-id="element-123">
            <div className="text-center mb-8" data-id="element-124">
              <p className="text-gray-400 mb-2" data-id="element-125">
                We could easily charge $97 for this system...
              </p>
              <p className="text-xl text-gray-300 mb-6" data-id="element-126">
                But our mission is to help{' '}
                <strong className="text-cyan-400" data-id="element-127">10,000 men</strong> reclaim
                their command this year.
              </p>

              <div className="inline-block bg-red-600 text-white px-6 py-3 rounded-lg mb-6 animate-pulse" data-id="element-128">
                <p className="font-bold" data-id="element-129">⚡ LAUNCH OFFER - 93% OFF ⚡</p>
              </div>
            </div>

            <div className="text-center mb-8" data-id="element-130">
              <p className="text-gray-400 mb-2" data-id="element-131">Regular Price:</p>
              <p className="text-4xl font-bold text-gray-500 line-through mb-4" data-id="element-132">
                $97
              </p>

              <p className="text-2xl font-bold text-cyan-400 mb-2" data-id="element-133">
                YOUR PRICE TODAY:
              </p>
              <p className="text-6xl md:text-7xl font-extrabold text-gradient mb-2" data-id="element-134">
                $6.39
              </p>
              <p className="text-xl text-green-400 font-bold" data-id="element-135">
                You save over $90... less than a coffee per week.
              </p>
            </div>

            <div className="bg-zinc-950 border border-zinc-800 rounded-xl p-6 mb-8" data-id="element-136">
              <p className="text-center text-gray-300" data-id="element-137">
                <strong className="text-white" data-id="element-138">ONE-TIME PAYMENT</strong> -
                Instant and lifetime access to the entire system
              </p>
            </div>

            <CTAButton size="large" className="w-full justify-center" onClick={handleBuyClick} data-id="element-139">
              BUY NOW - $6.39
            </CTAButton>

            <p className="text-center text-sm text-gray-500 mt-6" data-id="element-140">
              🔒 Secure payment • Instant access • 60-day guarantee
            </p>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4 bg-zinc-950" data-id="element-141">
        <div className="max-w-4xl mx-auto" data-id="element-142">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-143">
            Frequently Asked Questions
          </h2>

          <div className="space-y-4" data-id="element-144">
            <FAQItem question="Does it really work if I'm over 50?" answer="Absolutely. The protocol is based on basic human physiology. In fact, men over 50 often see the most dramatic changes because their margin for hormonal improvement is greater." data-id="element-145" />

            <FAQItem question="Do I need to go to a commercial gym?" answer="No. While ideal, Bonus #3 is designed so you can get incredible results with just a pair of dumbbells or even your own bodyweight at home." data-id="element-146" />

            <FAQItem question="Do I have to stop eating what I like?" answer="This is not a deprivation diet. We teach you to be a 'Carb Architect'. You'll learn when to eat what you like so it turns into muscle, not fat." data-id="element-147" />

            <FAQItem question="Is this program only for men in the USA?" answer="The content is universal. While the shopping guides are optimized for stores like Costco or Whole Foods common in the U.S., the principles work anywhere." data-id="element-148" />

            <FAQItem question="What if I'm already on TRT?" answer="This program is the perfect complement. Optimizing your nutrition and training will make your medical therapy work 10 times better with lower doses." data-id="element-149" />
          </div>
        </div>
      </section>

      {/* Guarantee */}
      <section className="py-16 px-4 bg-black" data-id="element-150">
        <div className="max-w-4xl mx-auto" data-id="element-151">
          <div className="bg-gradient-to-r from-green-900/20 to-emerald-900/20 border-2 border-green-500 rounded-2xl p-8 md:p-12 text-center" data-id="element-152">
            <ShieldCheckIcon className="h-20 w-20 text-green-500 mx-auto mb-6" aria-hidden="true" data-id="element-153" />

            <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-154">
              The <span className="text-green-400" data-id="element-155">"IRON-MEN"</span> Guarantee
            </h2>

            <p className="text-xl text-gray-300 leading-relaxed mb-6" data-id="element-156">
              Try it for{' '}
              <strong className="text-white" data-id="element-157">60 days risk-free</strong>. If
              after applying the 90-day protocol you don't feel more energized,
              don't see a reduction in your waistline, or simply aren't 100%
              satisfied, send us an email and we'll refund every penny.
            </p>

            <p className="text-lg text-gray-400 mb-6" data-id="element-158">
              No questions asked. You keep all the material anyway for the
              inconvenience.
            </p>

            <p className="text-2xl font-bold text-green-400" data-id="element-159">
              That is the size of our confidence.
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 px-4 bg-gradient-to-b from-zinc-950 to-black" data-id="element-160">
        <div className="max-w-4xl mx-auto" data-id="element-161">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-162">
            You Have Two Paths Before You Today
          </h2>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-163">
            <div className="bg-zinc-900 border border-red-500/50 rounded-xl p-8" data-id="element-164">
              <h3 className="text-2xl font-bold text-red-400 mb-4" data-id="element-165">Path A</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-166">
                You do nothing. You keep feeling fatigued, watching your belly
                grow year after year, and accepting that "this is just how it
                is".
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border-2 border-cyan-500 rounded-xl p-8" data-id="element-167">
              <h3 className="text-2xl font-bold text-cyan-400 mb-4" data-id="element-168">Path B</h3>
              <p className="text-gray-300 leading-relaxed" data-id="element-169">
                You take command. You invest less than the cost of a tank of gas
                in the system that will rebuild your presence, your energy, and
                your physique.
              </p>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-170">
            <p className="text-2xl font-bold text-white mb-6" data-id="element-171">
              The choice is yours,{' '}
              <span className="text-gradient" data-id="element-172">Architect</span>.
            </p>
          </div>

          <CTAButton size="large" className="w-full justify-center" onClick={scrollToCTA} data-id="element-173">
            INSTANT ACCESS TO THE PLAN
          </CTAButton>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 px-4 bg-zinc-950 border-t border-zinc-800" data-id="element-174">
        <div className="max-w-7xl mx-auto text-center text-gray-500 text-sm" data-id="element-175">
          <p data-id="element-176">© 2024 The Prime Architect 40+. All rights reserved.</p>
          <p className="mt-2" data-id="element-177">
            This product is for educational and informational purposes only.
          </p>
        </div>
      </footer>
    </div>;
}